// extracted by mini-css-extract-plugin
export default {"container":"GroupsPage_container__xN57u","legends":"GroupsPage_legends__7gaYl","otherPins":"GroupsPage_otherPins__+0YGA","bottomContainer":"GroupsPage_bottomContainer__4y410"};